
export class CardSuggestionTranslationDto {
    title: string;
    location: string;
    details : string;
    link: string;
    locale : string;
    cardSuggestions: {   
        photo: null
    };

    constructor(
        title: string,
        location: string,
        details : string,
        link: string,
        locale : string,
    ) {
        this.title = title;
        this.location = location;
        this.details = details;
        this.link = link;
        this.locale = locale;
        this.cardSuggestions = { photo: null };
    }
}